<template lang="pug">
  .page
    header.header-settings
      .tabs
        .tab.primary-text.active
          span General
    div
      form(@submit.prevent="submit")

        AlertBox(v-if="error", type="danger", :text="error")

        div.form-field
          label
            h6 Name
            input(v-model="$v.form.name.$model", type="text", placeholder="Board Name")
            .error(v-if="$v.form.name.$error && !$v.form.name.required") Field is required
        div.form-field
          label
            h6 Description
            textarea(v-model="form.description", placeholder="Board Description", @keypress.enter="submit")
        div.form-field
          .row
            .col
              label.custom-select
                input(v-model="form.public", type="radio", :value="true")
                .custom-select-container
                  .row.center
                    .col
                      font-awesome-icon.icon(:icon="['fad', 'lock-open-alt']")
                    .col
                      h6 Public
                      p Allow anyone to access
            .col
              label.custom-select
                input(v-model="form.public", type="radio", :value="false")
                .custom-select-container
                  .row.center
                    .col
                      font-awesome-icon.icon(:icon="['fad', 'lock-alt']")
                    .col
                      h6 Private
                      p Limit to company members
        div.form-field
          SubmitButton(label="Save", :formState="formState")

</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { form } from '@/mixins/form'

const formFields = ['name', 'description', 'public']

export default {
  name: 'BoardSettingsGeneral',
  mixins: [form],
  data () {
    return {
      formState: 'initial',
      form: {},
      error: null
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  mounted () {
    this.form = this.__formClone(this.board, formFields)
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    })
  },
  methods: {
    submit () {
      const updates = this.__formUpdates(this.board, this.form, formFields)

      //console.log(updates)

      if (this.__formInvalid(updates)) return

      this.formState = 'pending'
      this.$store.dispatch('boards/updateBoard', updates)
        .then(() => {
          this.formState = 'success'
        }, (error) => {
          this.formState = 'error'
          this.error = error
        })

    }
  },
  watch: {
    board (val) {
      this.form = this.__formClone(val, formFields)
    }
  }
}
</script>

<style scoped lang="stylus">

</style>
